// extracted by mini-css-extract-plugin
export default {"container":"Register_container__Wiq1g","actions":"Register_actions__JJADW"};